import { getHublessAppAuthResult } from './internal';
/**
 * Gets the current user's userInfo/login-verify response
 *
 * @example
 * ```ts
 * const userInfo = getAuth();
 *
 * const { email } = userInfo.user;
 * ```
 */
export const getAuth = () => getHublessAppAuthResult().auth;

/**
 * Gets the current user
 *
 * @example
 * ```ts
 * const { emails } = getUser();
 * ```
 * @deprecated Use `getAuth().user` instead.
 */
export const getUser = () => getHublessAppAuthResult().auth.user;

/**
 * Gets the current user's gates as a set
 *
 * Returns both v2 and v3 gates.
 *
 * Will append or omit extra gates via the ?gated and ?ungated query params.
 *
 * @example
 * ```ts
 * const myGate = gate('my-gate');
 *
 * const hasMyGate = getGates().has(myGate);
 * ```
 */
export const getGates = () => getHublessAppAuthResult().gates;